import { Button } from "react-admin";

// fa icon
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFontAwesome, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
library.add(fas, faTwitter, faFontAwesome);

export const ReorderButton = (props) => {
  return (
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            {" "}
            {props.index == 0 ? (
              <Button label="" disabled>
                <FontAwesomeIcon icon="fa-solid fa-angle-up" />
              </Button>
            ) : (
              <Button
                label=""
                onClick={() => {
                  props.reorderCallback(-1, props.index, props.parentIndex);
                }}
              >
                <FontAwesomeIcon icon="fa-solid fa-angle-up" />
              </Button>
            )}{" "}
          </td>
          <td>
            {" "}
            {props.index == props.total - 1 ? (
              <Button label="" disabled>
                <FontAwesomeIcon icon="fa-solid fa-angle-down" />
              </Button>
            ) : (
              <Button
                label=""
                onClick={() => {
                  props.reorderCallback(1, props.index, props.parentIndex);
                }}
              >
                <FontAwesomeIcon icon="fa-solid fa-angle-down" />
              </Button>
            )}{" "}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
